/**
 * This file serves as the component index
 * It manages exported components in one place and keeps them organized
 */
/**
 * Layout components
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ThemeToggle from './ThemeToggle';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  ThemeToggle,
};
